"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toProfileSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var contact_1 = require("../field-groups/contact");
var slice_1 = require("./slice");
var toProfileSlice = function (data, logger) {
    var profile = logger.required(contact_1.toContact(data.primary, logger));
    if (profile) {
        return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Profile)), { profile: profile }));
    }
    return undefined;
};
exports.toProfileSlice = toProfileSlice;
//# sourceMappingURL=profile-slice.js.map